export const NAVIGATION_CHANGING = 'NAVIGATION_CHANGING';
export const NAVIGATION_CHANGED = 'NAVIGATION_CHANGED';



// WEBPACK FOOTER //
// ./src/store/modules/navigation/actions.ts